import { STUDIO_BASE } from '@/features/studio/lib/studio-paths'
import { resolveCanvasScope, type CanvasScopeInput } from '@/features/studio/lib/canvas-scope'
import type { ShotCanvasIntent } from '@/features/studio/lib/shot-canvas-prompt'

export interface CanvasOpenParams extends CanvasScopeInput {
  return?: string
  label?: string
  characterId?: string
  locationId?: string
  workItemId?: string
  /** 分镜工作台勾选的镜头 public_id 列表 */
  shotIds?: string[]
  /** 分镜图 / 整段视频上下文 */
  intent?: ShotCanvasIntent
}

export function canvasPath(productionId: string, params?: CanvasOpenParams): string {
  const q = new URLSearchParams()
  if (params?.ctx) q.set('ctx', params.ctx)
  if (params?.return) q.set('return', params.return)
  if (params?.label) q.set('label', params.label)
  if (params?.shotId) q.set('shotId', params.shotId)
  if (params?.entityId) q.set('entityId', params.entityId)
  if (params?.characterId) q.set('characterId', params.characterId)
  if (params?.locationId) q.set('locationId', params.locationId)
  if (params?.workItemId) q.set('workItemId', params.workItemId)
  if (params?.scriptId != null) q.set('scriptId', String(params.scriptId))
  if (params?.episodeNo != null) q.set('episodeNo', String(params.episodeNo))
  if (params?.sceneNo != null) q.set('sceneNo', String(params.sceneNo))
  if (params?.shotIds?.length) q.set('shotIds', params.shotIds.join(','))
  if (params?.intent) q.set('intent', params.intent)

  const scope = resolveCanvasScope({
    ctx: params?.ctx,
    scopeType: params?.scopeType,
    scopeKey: params?.scopeKey,
    entityId: params?.entityId ?? params?.characterId ?? params?.locationId,
    shotId: params?.shotId,
    scriptId: params?.scriptId,
    episodeNo: params?.episodeNo,
    sceneNo: params?.sceneNo,
  })
  q.set('scope_type', scope.scopeType)
  q.set('scope_key', scope.scopeKey)

  const suffix = q.toString()
  return `${STUDIO_BASE}/productions/${productionId}/canvas${suffix ? `?${suffix}` : ''}`
}

export function canvasBoardPath(
  productionId: string,
  board: { scope_type: string; scope_key: string; title?: string },
  returnPath?: string,
): string {
  return canvasPath(productionId, {
    ctx: 'free',
    scopeType: board.scope_type,
    scopeKey: board.scope_key,
    label: board.title,
    return: returnPath,
  })
}

export function canvasBoardsListPath(productionId: string): string {
  return `${STUDIO_BASE}/productions/${productionId}/canvas-boards`
}
